<template>
    <nav>
        <ul class="pager">
            <li>
                <a href="#" @click.prevent="previous">
                    <i class="fa fa-angle-double-left"></i> Previous
                </a>
            </li>

            <li>
                <a href="#" @click.prevent="next">
                    Next <i class="fa fa-angle-double-right"></i>
                </a>
            </li>
        </ul>
    </nav>
</template>

<style>
    .pager-page {
        display: inline-block;
        padding: 5px 14px;
        background-color: #337ab7;
        color: #ffffff;
        border-radius: 15px;
    }
</style>

<script>
    import moment from 'moment'
    
    export default {
        props: ['date'],
        
        methods: {
            previous() {
                this.$emit('navigate', moment(this.date).add(-1, 'week').format('YYYY-MM-DD'))
            },

            next() {
                this.$emit('navigate', moment(this.date).add(1, 'week').format('YYYY-MM-DD'))
            }
        }
    }
</script>
